module.exports = __webpack_public_path__ + "img/collar_button_diameter.65f7c405.png";